
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["check-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.909.434a1 1 0 011.182 0l2.047 1.5a1 1 0 00.526.192l2.532.166a1 1 0 01.906.76l.603 2.465a1 1 0 00.28.485l1.833 1.754a1 1 0 01.206 1.165L18.9 11.197a1 1 0 00-.097.551l.276 2.523a1 1 0 01-.59 1.024l-2.324 1.022a1 1 0 00-.428.36l-1.41 2.11a1 1 0 01-1.112.405l-2.436-.71a1 1 0 00-.56 0l-2.436.71a1 1 0 01-1.112-.405l-1.41-2.11a1 1 0 00-.428-.36L2.51 15.295a1 1 0 01-.591-1.024l.276-2.523a1 1 0 00-.097-.55L.976 8.92a1 1 0 01.206-1.165l1.833-1.754a1 1 0 00.28-.485l.603-2.465a1 1 0 01.906-.76l2.532-.166a1 1 0 00.526-.192L9.91.434z","fill":"#4754FF"}}),_c('path',{attrs:{"d":"M7 10l2.5 2.5 4.5-5","stroke":"url(#paint0_linear_4542_2923)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_4542_2923","x1":"10.5","y1":"6.875","x2":"10.5","y2":"12.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff","stop-opacity":".8"}})])])])
          )
        }
      }
    